import type { ValidationContext, ValidationResult, ValidationStage } from './types';
import { getValidators } from './validatorRegistry';

export const runValidation = async (
  stage: ValidationStage,
  ctx: ValidationContext,
): Promise<ValidationResult[]> => {
  const validators = getValidators(stage);
  return Promise.all(validators.map(v => v.validate(ctx)));
};

export const hasBlockers = (results: ValidationResult[]): boolean =>
  results.some(r => r.blocker);

export const getIssues = (results: ValidationResult[]): ValidationResult[] =>
  results.filter(r => r.status !== 'pass');
